var chunkToChildrenMap = {
	"1067": [
		5450,
		6773,
		7488
	],
	"1911": [
		5450,
		6773,
		7488
	],
	"3839": [
		9315,
		8454,
		4956,
		8259,
		7763,
		6377,
		4605,
		9832,
		1504,
		4700,
		9375,
		9656,
		6774,
		6535,
		4928,
		1620,
		8392,
		1313,
		4140
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));